import React from 'react';
import { UserIcon } from 'lucide-react';
export type SampleReview = {
  label: string;
  quote: string;
  role: string;
};
export function SampleReviewCard({
  review
}: {
  review: SampleReview;
}) {
  return <figure className="flex h-full flex-col rounded-2xl border border-navy/10 bg-surface p-7 shadow-premium sm:p-8" data-id="element-228" data-mp="2qeqzl5otbzco">
      <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-sage" data-id="element-229" data-mp="2meyr0szf5t7b">{review.label}</p>
      <blockquote className="mt-5 flex-1 text-[15px] leading-7 text-slate" data-id="element-230" data-mp="3j34v9esfijl2">“{review.quote}”</blockquote>
      <figcaption className="mt-7 flex items-center gap-3" data-id="element-231" data-mp="3e6eib0bx843v">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-sage/15 text-sage" aria-hidden="true" data-id="element-232" data-mp="3a39ix6n50ijg">
          <UserIcon className="h-5 w-5" data-id="element-233" data-mp="353n4wuzhiy9l" />
        </span>
        <span data-id="element-234" data-mp="1yocrxr7e7j9g">
          <span className="block font-bold text-navy" data-id="element-235" data-mp="1yovzqf3bwr9r">[Verified Customer Name]</span>
          <span className="mt-0.5 block text-xs text-slate" data-id="element-236" data-mp="1tpjcht8jpi6n">{review.role}</span>
        </span>
      </figcaption>
    </figure>;
}
export function SampleReviewNotice() {
  return <p className="mx-auto mt-5 inline-block rounded-full border border-dashed border-amber bg-amber-pale px-4 py-2 text-xs font-medium text-navy" data-id="element-237" data-mp="27hj1bod243ip">
      Illustrative testimonial examples for layout purposes. Replace with verified customer reviews before publishing.
    </p>;
}